export default __webpack_public_path__ + "static/media/logo-ceyba-transp.0d5f5aff.png";